import { Reveal } from "../components/Reveal";
import { MapPin, HeartHandshake, Award, BadgePoundSterling, CarFront, ShieldCheck } from "lucide-react";

const ITEMS = [
  { icon: HeartHandshake, title: "Health & Safety", text: "Your well-being is our top priority, with a firm commitment to a safe, secure and supportive learning environment." },
  { icon: Award, title: "Quality Learning", text: "Structured, effective lessons that go beyond the test to create confident, capable drivers for life." },
  { icon: ShieldCheck, title: "Professional Ethics", text: "Our DVSA-approved instructors operate with the highest standards of integrity, professionalism and respect." },
  { icon: MapPin, title: "Your Driving Mentor", text: "Dedicated one-to-one guidance from your personal driving mentor throughout your entire journey." },
  { icon: CarFront, title: "Local Collection", text: "Suitable collection points may be arranged within our coverage areas, subject to instructor availability." },
  { icon: BadgePoundSterling, title: "No Hidden Charges", text: "Lessons from £14.95 with free theory test tuition and transparent block-booking value." },
];

export function WhyChooseUs() {
  return (
    <section id="why" className="section-pad" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <span className="overline">Why Choose Us</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight max-w-2xl">
            A driving school built around <span className="brand-text">your success</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-5">
          {ITEMS.map((it, i) => (
            <Reveal key={it.title} delay={i * 0.06} className={i % 5 === 0 ? "md:col-span-6" : "md:col-span-3"}>
              <div className="group card-soft p-7 h-full hover:-translate-y-1 hover:shadow-soft-lg transition-[transform,box-shadow] duration-300">
                <span className="inline-flex w-12 h-12 rounded-2xl brand-gradient text-white items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <it.icon size={22} strokeWidth={1.8} />
                </span>
                <h3 className="font-heading text-lg font-bold">{it.title}</h3>
                <p className="mt-2 text-sm text-neutral-500 leading-relaxed">{it.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
